export const SAVE_FORM_STRUCTURE = "SAVE_FORM_STRUCTURE"
export const GET_FORM_STRUCTURE_BY_URL_IDENTIFIER = "GET_FORM_STRUCTURE_BY_URL_IDENTIFIER" 
export const GET_ACTIVE_FORMS = "GET_ACTIVE_FORMS"
export const DELETE_FORM_STRUCTURE = "DELETE_FORM_STRUCTURE"
export const GET_FORM_STRUCTURE_BY_ID = "GET_FORM_STRUCTURE_BY_ID"
export const SHOW_ERROR_TOAST = "SHOW_ERROR_TOAST"
export const RESET_TOAST = "RESET_TOAST"

export const SAVE_USER_RESPONSE = "SAVE_USER_RESPONSE"

export const GET_FORM_BEHAVIOR_BY_URL_IDENTIFIER = "GET_FORM_BEHAVIOR_BY_URL_IDENTIFIER"

export const UPLOAD_IMAGE_FILE = "UPLOAD_IMAGE_FILE"
export const DELETE_IMAGE_FILE = "DELETE_IMAGE_FILE"
export const RESET_UPLOAD_DELETE_IMAGE_DATA = "RESET_UPLOAD_DELETE_IMAGE_DATA"
export const GET_APPLICANT_RESPONSE = "GET_APPLICANT_RESPONSE"
export const GET_CAPTCHA_VALUE = "GET_CAPTCHA_VALUE";
export const GET_PUBLIC_KEY = "GET_PUBLIC_KEY";

//login action
export const USER_LOGIN = "USER_LOGIN"
export let RESET_LOGIN_DATA = "RESET_LOGIN_DATA";

// payment Action
export const GET_PAYMENT_STATUS= "GET_PAYMENT_STATUS"
export const RESET_PAYMENT_STATUS= "RESET_PAYMENT_STATUS"
export const PAYMENT_INITIATE= "PAYMENT_INITIATE"
export const PAYMENT_LINK_DETAILS= "PAYMENT_LINK_DETAILS"
export const VERIFY_LINK_TOKEN= "VERIFY_LINK_TOKEN"



//dashboard action

export const DOWNLOAD_RECEIPT= "DOWNLOAD_RECEIPT"
export const DOWNLOAD_FORM= "DOWNLOAD_FORM"


export const GET_FORM_STATES= "GET_FORM_STATES"
export const GET_FORM_CITY_BY_STATE= "GET_FORM_CITY_BY_STATE"

// OTP Actions
export const VERIFY_OTP = "VERIFY_OTP"
export const SEND_OTP = "SEND_OTP"

/**
 * Add all of your actions above these functions.
 *
 * @export
 * @param {*} action
 * @returns
 */
export function pending(action) {
    return action + "_PENDING";
}

export function fulfilled(action) {
    return action + "_FULFILLED";
}

export function rejected(action) {
    return action + "_REJECTED";
}
